// Shared, framework-free data for the Roles & Permissions UI (role matrix +
// per-user override dialog both use this, so the two views never drift).
import { NAV } from "@/config/navigation";
import { MODULES as FRONTEND_MODULES } from "@/config/modules";

export const ACTIONS = ["view", "create", "edit", "delete"];
export const ACTION_LABEL = { view: "View", create: "Create", edit: "Edit", delete: "Delete" };

// Products has no entry in @/config/modules (it's managed via the bespoke
// Price List page, not the generic CrudPage) -- filled in here so its
// fields still show up in the field-visibility picker.
const PRODUCTS_FIELDS = [
  { name: "name", label: "Name" }, { name: "sku", label: "SKU" },
  { name: "category", label: "Category" }, { name: "price", label: "Price" },
  { name: "cost", label: "Cost" }, { name: "stock", label: "Stock" },
  { name: "recurring", label: "Billing" },
];

// Groups modules the same way the sidebar does (from navigation.js, the
// single source of truth for module labels), so this UI never drifts from
// what the nav actually shows.
function buildModuleGroups() {
  const groups = [];
  const singles = [];
  for (const item of NAV) {
    if (item.children) {
      const mods = item.children.filter((c) => c.module).map((c) => ({ key: c.module, label: c.label }));
      if (mods.length) groups.push({ label: item.label, items: mods });
    } else if (item.module) {
      singles.push({ key: item.module, label: item.label });
    }
  }
  if (singles.length) groups.push({ label: "Other", items: singles });
  return groups;
}

function buildPageItems() {
  const items = [];
  const add = (key, label) => { if (!items.some((i) => i.key === key)) items.push({ key, label }); };
  for (const i of NAV) {
    if (i.page) add(i.page, i.label);
    for (const c of i.children || []) if (c.page) add(c.page, i.page ? c.label : `${i.label}: My Day & Tasks`);
  }
  // Not a menu item of its own: unlocks the company-wide Work Dashboard and reports.
  add("dwr_management", "Daily Work: all staff (dashboard & reports)");
  return items;
}

function buildFieldsMap() {
  const map = { products: PRODUCTS_FIELDS };
  for (const cfg of Object.values(FRONTEND_MODULES)) {
    const collection = cfg.endpoint.replace(/^\//, "").replace(/-/g, "_");
    map[collection] = cfg.fields.map((f) => ({ name: f.name, label: f.label }));
  }
  return map;
}

export const MODULE_GROUPS = buildModuleGroups();
export const PAGE_ITEMS = buildPageItems();
export const FIELDS_MAP = buildFieldsMap();

export const emptyModulePerms = () => ({ view: false, create: false, edit: false, delete: false, hidden_fields: [] });
